import { COLOR_YELLOW_600, COLOR_YELLOW_700 } from '@alltrails/denali/tokens';
import { createNationalParkPinSvg } from './svgMarkerComponents';

const nationalParkPinSvg = createNationalParkPinSvg('national-park-pin', COLOR_YELLOW_600);
const activeNationalParkPinSvg = createNationalParkPinSvg('active-national-park-pin', COLOR_YELLOW_700);

export { nationalParkPinSvg, activeNationalParkPinSvg };
